import { useQuery } from '@tanstack/react-query';

import ISearchCriteria from '@models/dto/searchCriteria.dto';
import IPaginatedParams from '@models/paginated-params';
import { getCVVideoById, getCVVideos } from '../services/cvVideosServices';

export const useGetCVVideos = (
  paginatedParams: IPaginatedParams,
  searchCriteria: ISearchCriteria,
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: ['cv-videos', paginatedParams, searchCriteria],
    queryFn: () => getCVVideos(paginatedParams, searchCriteria),
    enabled,
  });
};

export const useGetCVVideoById = (
  id: string | undefined,
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: ['cv-video', id],
    queryFn: () => getCVVideoById(id),
    enabled,
  });
};
